export const getStatusColor = (status) => ({
  ACTIVE: 'bg-green-500/20 border-green-500 text-green-400',
  PRODUCTION: 'bg-blue-500/20 border-blue-500 text-blue-400',
  GROWING: 'bg-purple-500/20 border-purple-500 text-purple-400',
  BETA: 'bg-yellow-500/20 border-yellow-500 text-yellow-400'
}[status] || 'bg-gray-500/20 border-gray-500 text-gray-400');